import store from "@/store";

export default {
    getIsAdmin: function (){
        if (store.getters.getUserInfo && store.getters.getUserInfo.isAdmin){
            return store.getters.getUserInfo.isAdmin;
        }
        return false;
    },
    getRoleId: function (){
        if(store.getters.getUserInfo && store.getters.getUserInfo.role){
            return store.getters.getUserInfo.role.id;
        }
        return null;
    },
    getUserInfo: function (){
        return store.getters.getUserInfo;
    },
    getTenants: function (){
        if(store.getters.getUserInfo && store.getters.getUserInfo.role){
            return store.getters.getUserInfo.role.tenants;
        }
        return null;
    },
    getUserType: function (){
        return (store.getters.getUserInfo&&store.getters.getUserInfo.role&&store.getters.getUserInfo.role.userType);
    },
    checkInstitutionId: function (){
        return (store.getters.getUserInfo && store.getters.getUserInfo.institution && store.getters.getUserInfo.institution.id);
    },
    getInstitutionId: function (){
        if(store.getters.getUserInfo && store.getters.getUserInfo.institution){
            return store.getters.getUserInfo.institution.id;
        }
        return null;
    },
    getInstitutionName: function (){
        if(store.getters.getUserInfo && store.getters.getUserInfo.institution){
            return store.getters.getUserInfo.institution.name;
        }
        return null;
    },
    getInstitutionSubordinate: function (){
        if(store.getters.getUserInfo && store.getters.getUserInfo.institution){
            return store.getters.getUserInfo.institution.subordinate;
        }
        return null;
    },
    getAnalysisTemplateId: function (){
        if(store.getters.getUserInfo && store.getters.getUserInfo.institution){
            return store.getters.getUserInfo.institution.analysisTemplateId;
        }
        return null;
    },
    getOrganId: function (){
        if(store.getters.getUserInfo && store.getters.getUserInfo.institution){
            return store.getters.getUserInfo.institution.organId;
        }
        return null;
    },
    getTargetTemplateId: function (){
        if(store.getters.getUserInfo && store.getters.getUserInfo.institution){
            return store.getters.getUserInfo.institution.targetTemplateId;
        }
        return null;
    },
    getStreetCode: function (){
        if(store.getters.getUserInfo && store.getters.getUserInfo.code){
            return store.getters.getUserInfo.code.streetCode;
        }else{
            store.getters.getUserInfo.code = {};
        }
        return null;
    },
    getCode: function (){
        if(store.getters.getUserInfo && store.getters.getUserInfo.code){
            return store.getters.getUserInfo.code;
        }else{
            store.getters.getUserInfo.code = {};
        }
        return null;
    },
    getRole: function (){
        if(store.getters.getUserInfo && store.getters.getUserInfo.role){
            return store.getters.getUserInfo.role;
        }
        return null;
    },
    getInstitution: function (){
        if(store.getters.getUserInfo && store.getters.getUserInfo.institution){
            return store.getters.getUserInfo.institution;
        }
        return null;
    },
    getInstitutions: function (){
      if(store.getters.getUserInfo && store.getters.getUserInfo.institutions){
        return store.getters.getUserInfo.institutions;
      }
      return null;
    },
    gzTemplate: function (analysisTemplateId, targetTemplateId){
        let userInfo = this.getUserInfo();
        if(!analysisTemplateId&&(!userInfo||!userInfo.institution)){
            return false;
        }else if(!analysisTemplateId){
            analysisTemplateId = userInfo.institution.analysisTemplateId;
        }

        if(!targetTemplateId&&userInfo&&userInfo.institution){
            targetTemplateId = userInfo.institution.targetTemplateId;
        }

        if(targetTemplateId){
          return targetTemplateId!=2
              &&targetTemplateId!=7
              &&targetTemplateId!=8
              &&targetTemplateId!=15
              &&targetTemplateId!=16
              &&targetTemplateId!=17
              &&targetTemplateId!=18
              &&targetTemplateId!=19
              &&targetTemplateId!=20
              &&targetTemplateId!=21
              &&targetTemplateId!=22;
        }
        return (analysisTemplateId
          &&analysisTemplateId!=2
          &&analysisTemplateId!=7
          &&analysisTemplateId!=8
          &&analysisTemplateId!=15
          &&analysisTemplateId!=16
          &&analysisTemplateId!=17
          &&analysisTemplateId!=18
          &&analysisTemplateId!=19
          &&analysisTemplateId!=20
          &&analysisTemplateId!=21
          &&analysisTemplateId!=22
        );
    },
    szTemplate: function (analysisTemplateId, targetTemplateId){
        let userInfo = this.getUserInfo();
        if(!analysisTemplateId&&(!userInfo||!userInfo.institution)){
            return false;
        }else if(!analysisTemplateId){
            analysisTemplateId = userInfo.institution.analysisTemplateId;
        }

        if(!targetTemplateId&&userInfo&&userInfo.institution){
            targetTemplateId = userInfo.institution.targetTemplateId;
        }

      if(targetTemplateId){
        return targetTemplateId==2
            ||targetTemplateId==7
            ||targetTemplateId==8
            ||targetTemplateId==15
            ||targetTemplateId==16
            ||targetTemplateId==17
            ||targetTemplateId==18
            ||targetTemplateId==19
            ||targetTemplateId==20
            ||targetTemplateId==21
            ||targetTemplateId==22
        ;
      }
        return analysisTemplateId&&(
          analysisTemplateId==2
          ||analysisTemplateId==7
          ||analysisTemplateId==8
          ||analysisTemplateId==15
          ||analysisTemplateId==16
          ||analysisTemplateId==17
          ||analysisTemplateId==18
          ||analysisTemplateId==19
          ||analysisTemplateId==20
          ||analysisTemplateId==21
          ||analysisTemplateId==22
        );
    },
    shengYiTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 3);
    },
    huangPuTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 4);
    },
    huaDuTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 5);
    },
    yueXiuTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 6);
    },
    longGangTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 7);
    },
    fuTianTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 8);
    },
    haiZhuTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 9);
    },
    panYuTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 10);
    },
    baiYunTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 11);
    },
    foShanTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 12);
    },
    tianHeTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 13);
    },
    liWanTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 14);
    },
    baoAnTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 15);
    },
    nanShanTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 16);
    },
    luoHuTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 17);
    },
    yanTianTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 18);
    },
    longHuaTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 19);
    },
    pingShanTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 20);
    },
    guangMingTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 21);
    },
    daPengXinTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 22);
    },
    congHuaTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 23);
    },
    zengChengTemplate: function (analysisTemplateId, targetTemplateId){
        return this.checkTemplate(analysisTemplateId, targetTemplateId, 24);
    },
    checkTemplate: function (analysisTemplateId, targetTemplateId, targetAnalysisTemplateId){
        let userInfo = this.getUserInfo();
        if(!analysisTemplateId&&(!userInfo||!userInfo.institution)){
            return false;
        }else if(!analysisTemplateId){
            analysisTemplateId = userInfo.institution.analysisTemplateId;
        }
        if(!targetTemplateId&&userInfo&&userInfo.institution){
            targetTemplateId = userInfo.institution.targetTemplateId;
        }
        return (targetTemplateId&&targetTemplateId==targetAnalysisTemplateId)||analysisTemplateId&&analysisTemplateId==targetAnalysisTemplateId;
    },
    getConrrentAuthoritys: function (authoritys, name, url){
        if(!authoritys) {
            return false;
        }

        let result = false;
        for (let j= 0; j < authoritys.length; j++) {
            let data = authoritys[j];
            if(data.name != name){
                continue;
            }
            for (let z= 0; z < data.authoritys.length; z++) {
                let item = data.authoritys[z];
                if (item.url && item.url.length > 0 && item.url.indexOf(url) != -1){
                    result = true;
                    break;
                }
            }
            if(result){
                break;
            }
        }
        return result;
    }
}
